<template>
  <div class="Info">
    <div class="org">
      <div class="title htitle fs20">{{org.title}}</div>
      <div class="info">
        <div class="line" v-for="(value, k) in org.info">
          <div class="key">{{k}}</div>
          <div class="v">
            <div v-for="v in value">{{v}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="support">
      <div class="title htitle fs20">{{support.title}}</div>
      <div class="info">
        <div class="line" v-for="(value, k) in support.info">
          <div class="key" v-if="k">{{k}}</div>
          <div class="v">
            <div v-for="v in value">{{v}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   name: 'Info',
   props: {
   },
   computed: {
     org() {
       return this.$store.state.aboutus.org;
     },
     support() {
       return this.$store.state.aboutus.support;
     }
   },
   data () {
     return {
     }
   },
   mounted() {
     /* this.$http.get('/api/aboutus')
      *     .then(res => { */
           /* this.org = res.data.aboutus.org*/
           /* this.support = res.data.aboutus.support*/
     /* }) */
   }

 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Info{
   display: flex;
   align-items:center;
   flex-direction: column;
   padding-top: 6vw;
   color: #333333;
 }
 .org, .support{
   display: flex;
   justify-content: space-between;
   width: 62.5vw;
 }
 .title{
   color: #2A2A2A;
 }
 .info{
   width: 40.3vw;
 }
 .line{
   display: flex;
   line-height: 2.1em;
 }
 .key{
   width: 9em;
 }
 .v{
   display: flex;
   flex-wrap: wrap;
 }
 .support .v{
   color:#5C5C5C;
 }
 .v>div{
   margin-right: 3em;
 }
 .support .title{
   margin-top: 3.23vw;
 }
 .support .info{
   padding-top:3vw;
   border-top: 1px dashed #333333;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }
 .org{
   margin-bottom: 2.23vw;
   height: 10vw;
 }
 .org .info{
   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }
 .contact{
   line-height: 3.65vw;
 }

 .support{
   height: 6.5vw;
   margin-bottom: 5.2vw;
 }
</style>
